import { createFileRoute } from "@tanstack/react-router";

import { SpotlightBoard } from "~/components/feature/spotlight/SpotlightBoard";

export const Route = createFileRoute("/_app/dashboard/spotlight-board")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SpotlightBoard />;
}
